import { GET_CONFIG, GET_CONFIG_SUCCESS, GET_TOKEN, SET_MOBILE_MODE } from "./index";

export const getConfig = () => ({
  type: GET_CONFIG,
});

export const getConfigSuccess = (config) => ({
  type: GET_CONFIG_SUCCESS,
  config,
});

export const getToken = (tokenUrl) => ({
  type: GET_TOKEN,
  tokenUrl,
});

export const setMobileMode = (value) => ({
  type: SET_MOBILE_MODE,
  value,
});
